module.exports = __webpack_public_path__ + "img/pic_ranking_three.0869d749.png";